import "./contentWarning.scss";

export default function Contact() {

    return (
        <section>
            <h2 className="contentWarning__Header">Content Note</h2>
            <p className="contentWarning__Content">"Thank you for picking up The Poet Empress, as it is a story close to my heart.
                Please be advised that the book contains depictions of physical and sexual violence, which includes physical and 
                sexual abuse of minors and torture; substantial alcohol use; and violence committed by an intimate partner.
                Readers sensitive to these elements, please read with care."
            </p>
        </section>
    )
}